import Timer from "otp-timer";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Helmet } from "react-helmet";
import Switch from "@mui/material/Switch";
import { Link as RouterLink, useLocation, useNavigate, useParams } from "react-router-dom";


import ManagePeoples from "./ManagePeoples";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";

import { Icon } from "@iconify/react";

import Swal from "sweetalert2";
import GoogleMapWithSearch from "../../components/GoogleMapWithSearch";

import AddUpdateCentres from "../../components/AddUpdateCenters";
import { Box, Breadcrumbs, Dialog, DialogContent, DialogTitle, Link, Typography } from "@mui/material";

const AddCentre = () => {
  const navigate = useNavigate();

  const handleAddCenters = (status) => {
    navigate("/settings/centres");

    //  Router.push('/settings/centres');
  };

  return (
    <>
      <Helmet>
        <title>Spandan - Add Centre</title>
      </Helmet>

      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">

              <Box sx={{ mb: 2, margin: 0 }}>
                <Breadcrumbs separator="/" sx={{ mb: 1 }}>
                  <Link
                    component={RouterLink}
                    to="/settings"
                    underline="hover"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      color: "var(--app-text)",
                      fontWeight: 400,
                      fontStyle: "regular",
                    }}
                  >
                    Settings
                  </Link>

                  <Link
                    component={RouterLink}
                    to="/settings/centres"
                    underline="hover"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      color: "var(--app-text)",
                      fontWeight: 400,
                      fontStyle: "regular",
                    }}
                  >
                    Manage Centres
                  </Link>

                  <Typography
                    color="var(--app-text)"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      fontWeight: 600,
                    }}
                  >
                    Add New Centre
                  </Typography>
                </Breadcrumbs>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "Figtree",
                    color: "var(--app-text)",
                    fontSize: "20px",
                    fontStyle: "Bold",
                  }}
                >
                  Add New Centre
                </Typography>
              </Box>
            </div>

            <div className="row">
              <div className="col-md-12 ">
                <AddUpdateCentres
                  handleManageCenters={handleAddCenters}
                  type="add"
                />
              </div>
            </div>

            {/* <Topnav array="setup" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Centres = () => {
  const [manageCenters, setManageCentres] = useState(true);

  const [addCenters, setAddCentres] = useState(false);
  const handleManageCenters = (status) => {
    setManageCentres(status);
  };

  const handleAddCenters = (status) => {
    setAddCentres(false);
    setManageCentres(status);
  };

  return (
    <>
      {addCenters ? (
        <>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <br />
              <h5
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setAddCentres(false);
                }}
              >
                <strong>
                  <i className="fa fa-angle-left"></i> Add Center
                </strong>
              </h5>
              <UpdateCenters type="add" />
            </div>
          </div>
        </>
      ) : !manageCenters ? (
        <ManageCentres handleManageCenters={handleAddCenters} />
      ) : (
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <br />
            <h5>
              <strong>Manage Centres</strong>
            </h5>

            <button
              onClick={() => {
                setAddCentres(true);
              }}
              className="btn btn-added-primary2 mt-20 w-100"
            >
              <i className="fa fa-plus"></i>
              &nbsp; Add Centre
            </button>

            <div className="card2 mt-20" style={{ padding: "15px" }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div>
                    <img
                      src="https://weazy.in/assets/team/see.jpg"
                      alt="workspace"
                      style={{
                        width: "83px",
                        height: "83px",
                        borderRadius: "6%",
                      }}
                    />
                  </div>
                  <div>
                    <p style={{ marginLeft: "10px" }}>
                      <strong>Max Hospital Pvt. Ltd</strong>
                      <br />
                      <span>Primary Center | Hospital</span>
                      <br />
                      <span>+91 98765 43210</span>
                    </p>
                  </div>
                </div>
                <div
                  className="d-flex align-items-center"
                  onClick={() => {
                    setManageCentres(false);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="alert alert-default mb-0 py-1 px-2 ">
                    Primary{" "}
                  </div>
                  <i
                    className="fa fa-angle-right"
                    style={{ marginLeft: "10px", fontSize: "22px" }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ManageCentres = ({ handleManageCenters }) => {
  const [editCenter, setEditCenter] = useState(false);
  return (
    <>
      {" "}
      {editCenter ? (
        <>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <br />
              <h5
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditCenter(false);
                }}
              >
                <strong>
                  <i className="fa fa-angle-left"></i>&nbsp; Edit Center
                </strong>
              </h5>
              <UpdateCenters
                type="edit"
                handleManageCenters={handleManageCenters}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <br />
            <h5
              onClick={() => {
                handleManageCenters(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <strong>
                <i className="fa fa-angle-left"></i> &nbsp;&nbsp;Primary Centre
                (Max Health Pvt Ltd)
              </strong>
            </h5>

            <div className="card2 pt-20 mt-20" style={{ padding: "20px" }}>
              <h5>
                <strong>Centre Details</strong>
              </h5>
              <hr />

              <div className="mt-20 mt-20">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src="https://weazy.in/assets/team/see.jpg"
                        alt="workspace"
                        style={{
                          width: "66px",
                          height: "66px",
                          borderRadius: "6%",
                        }}
                      />
                    </div>
                    <div>
                      <p style={{ marginLeft: "10px" }}>
                        <strong>Max Hospital Pvt. Ltd</strong>
                        <br />
                        <span>Primary Center | Hospital</span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      setEditCenter(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <button className="btn btn-added-action me-1">
                      <Icon
                        icon="material-symbols:edit"
                        width="24"
                        height="24"
                        style={{ color: "#5751E9" }}
                      />
                    </button>
                  </div>
                </div>
              </div>
              <br />
              <div className="row mt-20">
                <div className="col-4">
                  <h6>
                    <strong style={{ color: "#A3A3A3", fontWeight: "800" }}>
                      CONTACT NUMBER
                    </strong>
                  </h6>
                  <p>+91 98765 43210</p>
                </div>

                <div className="col-8">
                  <h6>
                    <strong style={{ color: "#A3A3A3", fontWeight: "800" }}>
                      ADDRESS
                    </strong>
                  </h6>
                  <p>Haridwar Bypass, Dehradun, Uttarakhand - 248001</p>
                </div>
              </div>
              <br />
              <hr />

              <div className="row mt-20">
                <h6>
                  <strong>Members</strong>
                </h6>
              </div>

              <table className="table table-borderless ">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>MOBILE NUMBER</th>
                    <th>ROLE </th>
                    <th>DESIGNATION</th>
                  </tr>
                </thead>
                <tbody className="white-ss">
                  <tr>
                    <td>Akaash Singh Kaushal</td>
                    <td>9876543210</td>
                    <td>Admin </td>
                    <td className="d-flex align-items-center">
                      <span>Doctor &nbsp; &nbsp;</span>{" "}
                      <Alert severity="warning" sx={{ py: 0 }}>Invited</Alert>
                      <i
                        className="fas fa-angle-right"
                        style={{ marginLeft: "10px" }}
                      ></i>
                    </td>
                  </tr>
                </tbody>

                <tbody className="white-ss">
                  <tr>
                    <td>Akaash Singh Kaushal</td>
                    <td>9876543210</td>
                    <td>Admin </td>
                    <td>Doctor </td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <button
                className="btn btn-added-action mt-20 w-100"
                style={{ backgroundColor: "var(--app-surface)" }}
              >
                <i className="fa fa-plus"></i>
                &nbsp; Add Member
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const AddMember = () => {
  const Permissions = [
    {
      title: "People Management",
      items: ["Add and remove users, edit user roles"],
    },
    {
      title: "ECG Collection & Reports",
      items: [
        "View collection requests",
        "Create and delete collection requests",
        "View and download ECG reports",
        "Share ECG reports with patients",
      ],
    },
    {
      title: "ECG Interpretation",
      items: ["Share ECG reports with patients", "Interpret ECG report"],
    },
    {
      title: "Analytics",
      items: ["Access analytics and dashboard"],
    },
  ];

  return (
    <>
      <div className="row mt-2">
        <div className="col-4">
          <div className="form-group">
            <label>
              First Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-group">
            <label>
              Middle Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Middle Name"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-group">
            <label>
              Last Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
            />
          </div>
        </div>

        <div className="col-6">
          <div className="form-group">
            <label>
              Mobile Number<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Mobile Number"
            />
          </div>
        </div>

        <div className="col-6">
          <div className="form-group">
            <label>
              Email Address<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Email Address"
            />
          </div>
        </div>

        <div className="col-6">
          <div className="form-group">
            <label>
              Role<span className="text-danger">*</span>
            </label>
            <select className="form-control">
              <option value="admin">Admin</option>
            </select>
          </div>
        </div>

        <div className="col-6">
          <div className="form-group">
            <label>
              Designation<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Designation"
            />
          </div>
        </div>
      </div>

      <br />
      <h6>Permissions</h6>
      <br />
      <div className="row ">
        {Permissions.map((section, sIdx) => (
          <div key={sIdx}>
            <div className={`col-12 ${sIdx !== 0 ? "mt-20" : ""}`}>
              <strong>{section.title}</strong>
            </div>
            {section.items.map((label, iIdx) => (
              <div className="row" key={iIdx} style={{ marginTop: "10px" }}>
                <div className="col-8">{label}</div>
                <div className="col-4">
                  <Switch />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="col-4">
        <br />
        <button
          className="btn btn-added-action w-100 "
          style={{
            backgroundColor: "var(--app-surface)",
            color: "#5751E9",
            border: "1px solid #5751E9",
            borderRadius: "10px",
          }}
        >
          Send Invitation <i className="fa fa-plus"></i>&nbsp;
        </button>
      </div>
    </>
  );
};

const UpdateCenters = ({ type, item }) => {
  const [removeUser, setRemoveUser] = useState(false);

  const [address, setaddress] = useState(false);
  const [fulladdress, setfulladdress] = useState({
    floor: "",
    area: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
    fulladdress: "",
    latitude: "",
    longitude: "",
    district: "",
  });

  const update_location = (location) => {
    const address = {
      floor: location.floor,
      area: location.area,
      pincode: location.pincode,
      city: location.city,
      state: location.state,
      country: location.country,
      fulladdress: location.fulladdress,
      latitude: location.latitude,
      longitude: location.longitude,
      district: location.district,
    };
    setaddress(false);
    setfulladdress(address);
  };

  return (
    <>
      {/* Profile Card */}
      <div className="card2 pt-20 mt-20" style={{ padding: "20px" }}>
        <h5>
          <strong>Centre Details</strong>
        </h5>
        <hr />

        {/* Image Uploader */}
        <label>Centre Logo</label>
        <br />
        <div>
          <button
            style={{
              width: 115,
              height: 115,
              border: "1px dashed #5751E9",
              backgroundColor: "var(--app-surface-2)",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Icon
                icon="mdi:camera-plus"
                width="30"
                height="30"
                style={{ color: "#5751E9" }}
              />
              <p style={{ color: "var(--app-text-muted)", fontSize: "13px" }}>Add Image</p>
            </div>
          </button>
        </div>

        {/* Input Fields */}
        <div className="row mt-2">
          <div className="col-6">
            <div className="form-group">
              <label>
                Centre Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Centre Name"
              />
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label>
                Centre Type<span className="text-danger">*</span>
              </label>
              <select className="form-control">
                <option value="hospital">Hospital</option>
              </select>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label>
                Centre Contact Number<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Centre Contact Number"
              />
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label>
                Centre Address<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                onClick={() => setaddress(true)}
                value={fulladdress.fulladdress}
                className="form-control"
                placeholder="Select Centre Address"
                readOnly
              />
            </div>
          </div>

          <div className="col-12">
            <label>Organisation Images (upto 4)</label>
            <div style={{ marginTop: "0px" }}>
              <button
                style={{
                  height: 131,
                  width: 680,
                  border: "1px dashed #5751E9",
                  backgroundColor: "var(--app-surface-2)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    icon="mdi:camera-plus"
                    width="30"
                    height="30"
                    style={{ color: "#5751E9" }}
                  />
                  <span style={{ marginTop: 8, fontSize: 13 }}>Add Images</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Members Section */}
      <div className="card2 pt-20" style={{ padding: "20px" }}>
        <h5>
          <strong>Add Members</strong>
        </h5>
        <hr />
        {type == "update" && (
          <table className="table table-borderless">
            <thead>
              <tr>
                <th>NAME</th>
                <th>MOBILE NUMBER</th>
                <th>ROLE</th>
                <th>DESIGNATION</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="white-ss">
              {[1, 2].map((_, index) => (
                <tr key={index}>
                  <td>Akaash Singh Kaushal</td>
                  <td>9876543210</td>
                  <td>Admin</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <span>Doctor &nbsp;&nbsp;</span>
                      <Alert severity="warning" sx={{ py: 0 }}>Invited</Alert>
                    </div>
                  </td>
                  <td>
                    <IconButton size="small" aria-label="row actions"><i className="fa fa-ellipsis-v" /></IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <button
          className="btn btn-added-action w-100"
          style={{
            backgroundColor: "var(--app-surface)",
            color: "#5751E9",
            border: "1px solid #5751E9",
          }}
        >
          <i className="fa fa-plus"></i>&nbsp; Add Member
        </button>
        <br />
        <br />

        <AddMember />
      </div>

      {/* Save & Delete Buttons */}
      {/* <div className="col-12 mt-3 mb-5">
        <button className="btn btn-added-primary mt-20 w-25">
          Save Details
        </button>
        &nbsp;
        {type == "update" && (
          <button
            onClick={() => {
              Swal.fire({
                title:
                  '<i class="fa fa-exclamation-triangle" style="font-size: 57px;margin-top:30px;color:#E72020"></i> <br/>  <br/>  Delete Centre?',
                html: "Are you sure you want to <strong>delete XYZ Centre of Max Health Pvt Ltd</strong>?  Once deleted, this centre can not be retrieved and all centre data will be lost",
                // icon: 'error',
                iconColor: "#E72020", // optional: custom icon color
                showCancelButton: true,
                confirmButtonText: "Yes, Delete Centre",
                cancelButtonText: "No, Go Back",
                customClass: {
                  popup: "custom-swal-popup",
                  confirmButton: "btn btn-added-danger swal-pop-btn", // Bootstrap or your own class
                  cancelButton: "btn btn-added-primary swal-pop-btn",
                },
                buttonsStyling: false, // to apply custom class styles
              }).then((result) => {
                if (result.isConfirmed) {
                  setRemoveUser(true);
                }
              });
            }}
            className="btn btn-added-danger mt-20 w-25"
          >
            Delete Centre
          </button>
        )}
      </div> */}

      <Dialog
        open={address}
        onClose={() => setaddress(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {/* <h5>Select your Address</h5> */}
        </DialogTitle>

        <DialogContent>
          <GoogleMapWithSearch onAddressChange={update_location} />
        </DialogContent>
      </Dialog>

    </>
  );
};
export default AddCentre;
